import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/Navigation";
import FoundationFooter from "@/components/FoundationFooter";
import RouteTransition from "@/components/RouteTransition";
import SmoothScroll from "@/components/SmoothScroll";
import Foundation from "@/pages/Foundation";
import NewBeginnings from "@/pages/NewBeginnings";
import Unspoken from "@/pages/Unspoken";
import NextMove from "@/pages/NextMove";
import FoundationContact from "@/pages/FoundationContact";
import OurStory from "@/pages/OurStory";
import Updates from "@/pages/Updates";
import Team from "@/pages/Team";
import Donate from "@/pages/Donate";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="min-h-screen bg-black text-white" data-testid="app-root">
      <BrowserRouter>
        <SmoothScroll>
          <RouteTransition />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<Navigate to="/foundation" replace />} />
              <Route path="/foundation" element={<Foundation />} />
              <Route path="/foundation/our-story" element={<OurStory />} />
              <Route path="/foundation/team" element={<Team />} />
              <Route path="/foundation/our-work" element={<Navigate to="/foundation" replace />} />
              <Route path="/foundation/updates" element={<Updates />} />
              <Route path="/foundation/new-beginnings" element={<NewBeginnings />} />
              <Route path="/foundation/unspoken" element={<Unspoken />} />
              <Route path="/foundation/next-move" element={<NextMove />} />
              <Route path="/foundation/sponsors" element={<Navigate to="/foundation/new-beginnings" replace />} />
              <Route path="/foundation/contact" element={<FoundationContact />} />
              <Route path="/foundation/donate" element={<Donate />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Navigate to="/foundation" replace />} />
            </Routes>
          </main>
          <FoundationFooter />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
